import { Rect } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
import Annotation from './annotation';
const Highlight = props => {
  const scale = props.scale,
    pageHeight = props.pageHeight,
    offset = props.offset,
    dpiScale = props.dpiScale,
    selectedID = props.selectedID,
    annotation = props.annotation,
    onDragEnd = props.onDragEnd;
  const rectsString = annotation.highlightAnnotation.rectsString,
    colorString = annotation.colorString,
    id = annotation.id;
  const parsedRectangles = annTools.parseRectangles(rectsString);
  const transposedRectangles = parsedRectangles.map(rectangle => {
    const newX = rectangle[0] * scale;
    const newY = pageHeight - rectangle[1] * scale;
    const newWidth = rectangle[2] * scale;
    const newHeight = rectangle[3] * scale;
    // coordinate system discrepency, lower left (pdf) vs upper left (canvas)
    const yAdjusted = newY - newHeight;
    return {
      x: newX - offset.x * scale,
      y: yAdjusted + offset.y * scale,
      width: newWidth,
      height: newHeight
    };
  });
  const color = annTools.parseColor(colorString);
  const colorRGBAString = "rgba(".concat(color[0], ",").concat(color[1], ",").concat(color[2], ",0.50)");
  return /*#__PURE__*/React.createElement(Annotation, {
    hideSelectionBox: true,
    selectedID: selectedID,
    annotationID: id,
    dpiScale: dpiScale,
    scale: scale,
    key: id,
    onDragEnd: onDragEnd
  }, transposedRectangles.map((box, index) => /*#__PURE__*/React.createElement(Rect
  /* eslint-disable react/no-array-index-key */, {
    key: "".concat(id, "-").concat(index)
    /* eslint-enable react/no-array-index-key */,
    x: box.x / dpiScale,
    y: box.y / dpiScale,
    width: box.width / dpiScale,
    height: box.height / dpiScale,
    fill: colorRGBAString
  })));
};
Highlight.propTypes = {
  annotation: PropTypes.shape({
    colorString: PropTypes.string,
    id: PropTypes.string,
    highlightAnnotation: PropTypes.shape({
      rectsString: PropTypes.string
    })
  }).isRequired,
  dpiScale: PropTypes.number.isRequired,
  offset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  pageHeight: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired,
  selectedID: PropTypes.string.isRequired
};
export default Highlight;